package se.mittpass.web

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
fun rememberWindowWidth(): Int {
    var windowWidth by remember { mutableStateOf(window.innerWidth) }
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            val current = window.innerWidth
            if (current != windowWidth) {
                windowWidth = current
            }
        }
        window.addEventListener("resize", listener)
        window.addEventListener("orientationchange", listener)
        onDispose {
            window.removeEventListener("resize", listener)
            window.removeEventListener("orientationchange", listener)
        }
    }
    return windowWidth
}
